export const DIAGNOSTICS_ROUTE = '/diagnostics';

export const INCIDENT_ROUTE_PATTERN = `${DIAGNOSTICS_ROUTE}/incidents/:reference`;

export const incidentPath = (reference: string): string => `${DIAGNOSTICS_ROUTE}/incidents/${reference}`;

type OpenedFromTriage = { openedFromTriage: true };

export const OPENED_FROM_TRIAGE: OpenedFromTriage = { openedFromTriage: true };

export const wasOpenedFromTriage = (locationState: unknown): boolean =>
  (locationState as Partial<OpenedFromTriage> | null)?.openedFromTriage === true;
